import React from 'react'

export const FacebookIcon = () => {
  return (
    <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M29.1459 14.7107C29.1459 6.72191 22.6712 0.247192 14.6824 0.247192C6.69359 0.247192 0.218872 6.72191 0.218872 14.7107C0.218872 21.9312 5.5071 27.9143 12.4225 28.9991V18.8916H8.75006V14.7107H12.4225V11.5242C12.4225 7.89984 14.5807 5.897 17.8858 5.897C19.4678 5.897 21.1232 6.1795 21.1232 6.1795V9.73888H19.2983C17.5016 9.73888 16.9423 10.8547 16.9423 11.9988V14.7107H20.9537L20.3124 18.8916H16.9423V28.9991C23.8577 27.9143 29.1459 21.9312 29.1459 14.7107Z" fill="#F858A5"/>
</svg>
  )
}
